import pt from 'prop-types';
import { connect } from 'react-redux';
import { Component } from 'react';
import { ContentCard } from '@mews-commander/ui';
import { IconButton, IconName } from '@optimus-web/core';
import { deferFocus } from '@mews-commander/utils';

export interface EntityManagerProps {
    scope: string;
    onAdd?: () => void;
    onEdit?: () => void;
    onUnmount?: () => void;
    noTitleMargin?: boolean;
    readOnlyForm?: boolean;
}

interface EntityManagerReduxProps {
    deferFocus: $TSFixMe;
}

export default ({ Title, Table, AddForm, EditForm, DeleteDialog }: $TSFixMe) => {
    class EntityManager extends Component<EntityManagerProps & EntityManagerReduxProps> {
        static propTypes = {
            scope: pt.string.isRequired,
            onAdd: pt.func,
            onUnmount: pt.func,
            noTitleMargin: pt.bool,
            deferFocus: pt.func.isRequired,
            readOnlyForm: pt.bool,
        };

        iconButton: $TSFixMe;

        componentWillUnmount() {
            const { onUnmount } = this.props;
            if (onUnmount) {
                onUnmount();
            }
        }

        handleFormClosed = () => {
            if (this.iconButton) {
                this.props.deferFocus(this.iconButton, { selector: null });
            }
        };

        render() {
            const { onAdd, scope, onUnmount, onEdit, noTitleMargin, readOnlyForm, ...other } = this.props;

            const buttonProps = {
                onClick: onAdd,
                icon: IconName.Add,
                ref: (c: $TSFixMe) => (this.iconButton = c),
                scope,
                variant: 'ghost' as const,
            };

            const formProps = {
                ...other,
                onEdit,
                sidebarDidClose: this.handleFormClosed,
                readOnlyForm,
            };

            return (
                <ContentCard
                    title={Title}
                    actions={readOnlyForm ? null : <IconButton {...buttonProps} type="submit" />}
                    data-test-entity-manager-id={scope}
                >
                    {Table && <Table scope={scope} {...other} readOnlyForm={readOnlyForm} />}
                    {AddForm && <AddForm scope={scope} form={`addForm-${scope}`} {...formProps} />}
                    {EditForm && <EditForm scope={scope} form={`editForm-${scope}`} {...formProps} />}
                    {DeleteDialog && <DeleteDialog scope={scope} {...formProps} />}
                </ContentCard>
            );
        }
    }
    return connect(undefined, { deferFocus })(EntityManager) as React.ComponentType<EntityManagerProps>;
};
